import {
	gsap
} from "gsap"
/********************************************************************************

	SYNCER 〜 知識、感動をみんなと同期(Sync)するブログ

	* 配布場所
	https://syncer.jp/jquery-modal-window

	* 最終更新日時
	2015/08/17 15:55

	* 作者
	あらゆ

	** 連絡先
	Twitter: https://twitter.com/arayutw
	Facebook: https://www.facebook.com/arayutw
	Google+: https://plus.google.com/114918692417332410369/
	E-mail: info@syncer.jp

	※ バグ、不具合の報告、提案、ご要望など、お待ちしております。
	※ 申し訳ありませんが、ご利用者様、個々の環境における問題はサポートしていません。

********************************************************************************/

//グローバル変数
var nowModalSyncer = null; //現在開かれているモーダルコンテンツ
var modalClassSyncer = "modal"; //モーダルを開くリンクに付けるクラス名

//モーダルのリンクを取得する
var modals = document.getElementsByClassName(modalClassSyncer);

//モーダルウィンドウを出現させるクリックイベント
for (var i = 0, l = modals.length; l > i; i++) {

	//全てのリンクにタッチイベントを設定する
	modals[i].onclick = function () {

		//ボタンからフォーカスを外す
		this.blur();

		//ターゲットとなるコンテンツを確認
		var target = this.getAttribute("data-target");

		//ターゲットが存在しなければ終了
		if (typeof (target) == "undefined" || !target || target == null) {
			return false;
		}

		//コンテンツとなる要素を取得
		nowModalSyncer = document.getElementById(target);

		//ターゲットが存在しなければ終了
		if (nowModalSyncer == null) {
			return false;
		}

		//キーボード操作などにより、オーバーレイが多重起動するのを防止する
		if (document.querySelectorAll("#modal-overlay")[0]) return false; //新しくモーダルウィンドウを起動しない
		//if($("#modal-overlay")[0]) $("#modal-overlay").remove() ;		//現在のモーダルウィンドウを削除して新しく起動する

		//オーバーレイを出現させる
		let morDom = document.createElement("div")
		morDom.setAttribute("id", "modal-overlay")
		morDom.style.display = "block"
		document.body.appendChild(morDom)
		gsap.fromTo("#modal-overlay", {
			opacity: 0,
		}, {
			opacity: 1,
			duration: 0.1,
		})

		//コンテンツをセンタリングする
		//centeringModalSyncer() ;

		//コンテンツをフェードインする
		nowModalSyncer.style.display = "block"
		gsap.fromTo(nowModalSyncer, {
			opacity: 0,
		}, {
			opacity: 1,
			duration: 0.3,
		})

		document.querySelectorAll("#modal-overlay,#modal-close").forEach((node) => {
			node.addEventListener("click", () => {
				gsap.to([`#${target}`, "#modal-overlay"], {
					opacity: 0,
					duration: 0.1,
					onComplete: () => {
						document.querySelector("#modal-overlay").remove()
						nowModalSyncer.style.display = "none"
						nowModalSyncer = null;
					},
				})
			})
		})

	}

}

/*$('.modal').on('click', function(e){
	var target = $(this).data('target');
	$('#' + target + "#modal-overlay").addClass('appear');
});

$('#modal-overlay').on('click', function(e){
	$('.modal-content').removeClass('appear');
	$(this).removeClass('appear');
});

$('#modal-close').on('click', function(e){
	$(this).parent().removeClass('appear');
	$('#modal-overlay').removeClass('appear');
});*/